import { displayValue } from "./utils/mapperUtils";

export const mapCard = (json) => {
    const { KpiID, Description, KpiType } = json;
    return [
        [{ labels: ["kpiId"], value: displayValue(KpiID), type: "string", basis: "20%" }],
        [
            {
                labels: ["description"],
                value: displayValue(Description),
                type: "string",
                basis: "50%",
            },
        ],
        [
            {
                labels: ["kpiType"],
                value: displayValue(KpiType),
                type: "number",
            },
        ],
    ];
};

const mapper = (json, card) => {
    return {
        ...json,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
    };
};

const header = [
    {
        label: ["Identifier"],
        align: "left",
        basis: "20%",
        columnName: "KpiID",
        sortable: true,
    },
    {
        label: ["Description"],
        align: "left",
        basis: "50%",
        columnName: "Description",
        sortable: true,
    },
    {
        label: ["Kpi Type"],
        align: "center",
        columnName: "KpiType",
        sortable: true,
    },
];

const kpiMapper = {
    map: mapper,
    header,
};

export default kpiMapper;
